<template>
  <div class="jy-form-container">
    <!-- 按钮组 -->
    <div class="button-ground">
      <el-button type="primary" @click="onSave">保存</el-button>
    </div>
    <div class="form-line"></div>
    <div class="jy-line-container">
      <AngleDouble title="对账信息">
        <el-form
            :model="baseFormInfo"
            label-width="170px"
            label-position="right"
        >
          <el-row :gutter="gutter">
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="对账单号："
                  class="jy-form-input"
              >
                <el-input disabled value="保存时自动生成"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="结算对象："
                  class="jy-form-input"
              >
                <div style="display: flex; width: 100%;">
                  <el-select
                      clearable
                      v-model="baseFormInfo.baseInfo.objectStatusConfDictId"
                      :disabled="true"
                      placeholder="对象类型"
                      @visible-change="visibleChange($event, 1)"
                  >
                    <el-option
                        v-for="(item, index) in objectStatusOptions"
                        :key="index"
                        :label="item.val"
                        :value="item.confDictId"
                    />
                  </el-select>
                  <el-select
                      clearable
                      v-model="baseFormInfo.baseInfo.objectName"
                      :disabled="disabledTable"
                      placeholder="对象名称"
                      @visible-change="visibleChange($event, 2)"
                      @change="onSelectObjectName"
                      style="margin-left: 10px"
                  >
                    <el-option
                        v-for="(item, index) in objectNameOptions"
                        :key="index"
                        :label="item.userMemberName"
                        :value="item.memberId"
                    />
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="对账部门："
                  class="jy-form-input"
              >
                <el-select
                    v-model="baseFormInfo.baseInfo.reconciliationDept"
                    placeholder="请选择"
                    clearable
                    @visible-change="visibleChange($event, 3)"
                    @change="
                    onSelect(
                      $event,
                      storageOptions,
                      ['reconciliationDeptId', 'reconciliationDept'],
                      ['storageId', 'storageName']
                    )
                  "
                >
                  <el-option
                      v-for="(item, index) in storageOptions"
                      :key="index"
                      :label="item.storageName"
                      :value="item.storageId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="结算币种："
                  class="jy-form-input"
              >
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.currency"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 4)"
                    :disabled="disabledTable"
                >
                  <el-option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :label="item.cnName"
                      :value="item.cnName"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="应收合计："
                  class="jy-form-input"
              >
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.financeInAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="应付合计："
                  class="jy-form-input"
              >
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.financeOutAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="结算金额："
                  class="jy-form-input"
              >
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.settlementAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="对账单结算币种："
                  class="jy-form-input"
              >
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.statementCurrencyId"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 4)"
                    @change="onSelectCurrency"
                >
                  <el-option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :label="item.cnName"
                      :value="item.currencyId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="换算汇率："
                  class="jy-form-input"
              >
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.statementCurrencyExchange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="换算金额："
                  class="jy-form-input"
              >
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.currencyAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  :rules="[{ required: true, message: '必填' }]"
                  label="核准金额："
                  class="jy-form-input"
              >
                <el-input
                    v-model="baseFormInfo.baseInfo.approvalAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="资金账号：" class="jy-form-input">
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.zjAccount"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 6)"
                >
                  <el-option
                      v-for="(item, index) in zjAccountOptions"
                      :key="index"
                      :label="item.zjAccountShow"
                      :value="item.zjAccount"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：" class="jy-form-input">
                <el-input
                    v-model="baseFormInfo.baseInfo.writeoffComment"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="账单明细">
        <div class="button-ground">
          <el-button
              v-if="!baseFormInfo.baseInfo.billInfosType || baseFormInfo.baseInfo.billInfosType.includes('finance_in')"
              plain
              class="jy-button"
              @click="onAddWaybill"
          >添加运单</el-button
          >
          <el-button
              v-if="baseFormInfo.baseInfo.billInfosType && baseFormInfo.baseInfo.billInfosType.includes('finance_record_group')"
              plain
              class="jy-button"
              @click="onAddFinanceRecordGroup"
          >添加运费单</el-button
          >
          <!-- <el-button plain class="jy-button">添加其他支出</el-button> -->
          <el-button plain class="jy-button" @click="onDelWaybill"
          >移除</el-button
          >
        </div>
        <div class="table-ground" style="margin-top: 20px">
          <el-table
              class="jy-common-table"
              header-align="center"
              border
              stripe
              :highlight-current-row="true"
              style="width: 100%"
              :data="financeTable"
              @selection-change="handleMxTableChange"
              show-summary
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column align="center" type="selection" width="55" />
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="financeTypeShow"
                label="收支类型"
            >
            </el-table-column>
            <el-table-column
                width="150"
                show-overflow-tooltip
                align="center"
                prop="financeNumber"
                label="运费单号"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="documentStatusShow"
                label="单据类型"
            >
            </el-table-column>
            <el-table-column
                width="150"
                show-overflow-tooltip
                align="center"
                prop="documentNumber"
                label="来源单据"
            >
            </el-table-column>
<!--            <el-table-column-->
<!--                show-overflow-tooltip-->
<!--                align="center"-->
<!--                prop="categoryName"-->
<!--                label="费项类型"-->
<!--            >-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                show-overflow-tooltip-->
<!--                align="center"-->
<!--                prop="serviceName"-->
<!--                label="费项"-->
<!--            >-->
<!--            </el-table-column>-->
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectStatus"
                label="结算对象类型"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectName"
                label="结算对象"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="currency"
                label="结算币种"
            >
            </el-table-column>
<!--            <el-table-column-->
<!--                show-overflow-tooltip-->
<!--                align="center"-->
<!--                prop="noTaxTotalAmount"-->
<!--                label="不含税总价"-->
<!--            >-->
<!--            </el-table-column>-->
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="financeInAmount"
                label="应收金额"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="financeOutAmount"
                label="应付金额"
            >
            </el-table-column>
<!--            <el-table-column-->
<!--                show-overflow-tooltip-->
<!--                align="center"-->
<!--                prop="importExportTypeShow"-->
<!--                label="进出口类型"-->
<!--            >-->
<!--            </el-table-column>-->
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="remarks"
                label="备注"
            >
            </el-table-column>
            <el-table-column
                width="150"
                show-overflow-tooltip
                align="center"
                prop="createTime"
                label="创建日期"
            >
            </el-table-column>
          </el-table>
        </div>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="附件信息">
        <commonFuJian ref="domCommonFuJian"></commonFuJian>
      </AngleDouble>
    </div>
    <!-- 添加运单 -->
    <MessageBox
        :show="addWaybillVisible"
        inputType="input"
        formTitle="运单号"
        @onMessageBoxCancel="onCancelAddWaybill"
        @onMessageBoxConfirm="onConfirmAddWaybill"
    >
    </MessageBox>
    <!-- 添加运费单 -->
    <MessageBox
        :show="addFinanceRecordGroupVisible"
        inputType="input"
        formTitle="运费单单号"
        @onMessageBoxCancel="onCancelAddFinanceRecordGroup"
        @onMessageBoxConfirm="onConfirmAddFinanceRecordGroup"
    >
    </MessageBox>
  </div>
</template>

<script>
import { Api } from "@/assets/js/api";
import MessageBox from "@/components/messageBox/index.vue";
import utils from "@/assets/js/tool.js";
import commonFuJian from "@/components/fuJian/index.vue";
import AngleDouble from "@/components/details/angleDouble.vue";
import EnterpriseNoSetting from "@/assets/js/EnterpriseNoSetting.js";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
export default {
  name: "CenerateStatement",
  components: {
    MessageBox,
    commonFuJian,
    AngleDouble
  },
  data() {
    return {
      // 控件大小控制
      gutter: 12,
      span: 6,

      domCommonFuJian: null,

      baseObj: {
        baseInfo: {
          approvalAmount: "",
          businessName: "",
          currency: "",
          currencyId: "",
          currencyAmount: "",
          financeInAmount: "",
          financeOutAmount: "",
          objectName: "",
          objectNumber: "",
          objectStatus: "",
          objectStatusConfDictId: "",
          reconciliationDept: "",
          reconciliationDeptId: "",
          settlementAmount: "",
          statementCurrencyId: "",
          statementCurrency: "",
          statementCurrencyExchange: "0",
          statementModeConfDictId: "",
          statementType: "pu_tong:statement_type",
          writeoffComment: "",
          zjAccount: "",
          billInfosType: [],
        },
      },

      financeTable: [],
      baseFormInfo: {
        baseInfo: {
          approvalAmount: "",
          businessName: "",
          currency: "",
          currencyId: "",
          currencyAmount: "",
          financeInAmount: "",
          financeOutAmount: "",
          objectName: "",
          objectNumber: "",
          objectStatus: "",
          objectStatusConfDictId: "",
          reconciliationDept: "",
          reconciliationDeptId: "",
          settlementAmount: "",
          statementCurrencyId: "",
          statementCurrency: "",
          statementCurrencyExchange: "0",
          statementModeConfDictId: "",
          statementType: "pu_tong:statement_type",
          writeoffComment: "",
          zjAccount: "",
          billInfosType: [],
        },
      },
      bBaseFormInfo: {},
      disabledTable: true,

      objectStatusOptions: [],
      objectNameOptions: [],
      storageOptions: [],
      currencyOptions: [],
      statementModeOptions: [],
      zjAccountOptions: [],

      originalCurrency: {
        originCurrencyId: "",
        statementCurrency: "",
      },

      commonJumpKeys: EnterpriseNoSetting.keys,

      // 添加运单
      addWaybillVisible: false,
      //运费单
      addFinanceRecordGroupVisible: false,

      mxTableSelect: [],

      submitObj: {
        approvalAmount: "",
        businessName: "",
        currency: "",
        currencyId: "",
        currencyAmount: "",
        financeInAmount: "",
        financeOutAmount: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        reconciliationDeptId: "",
        settlementAmount: "",
        statementCurrency: "",
        statementCurrencyId: "",
        statementCurrencyExchange: "",
        statementModeConfDictId: "",
        statementType: "pu_tong:statement_type",
        writeoffComment: "",
        zjAccount: "",
      },

      annexTable: [],
    };
  },

  watch: {
    '$route': {
      handler: function(newValue, oldValue) {
        const query = newValue.query;
        const meta = newValue.meta;
        let clearStatus = sessionStorage.getItem(
            "clearReceivableManagementCenerateStatement"
        );
        if (meta.china == "生成应收对账单" && clearStatus == 1) {
          this.financeTable = [];
          this.annexTable = [];
          console.log("query",query);
          this.baseFormInfo.baseInfo.billInfosType = [];
          this.baseFormInfo.baseInfo.billInfosType.push(query.financeType);
          if (
              query &&
              query.currency &&
              query.objectStatus &&
              (query.financeType == "finance_in" || query.financeType == "finance_record_group"  )&&
              query.objectName
          ) {
            this.disabledTable = true;
            this.baseFormInfo.baseInfo.objectStatus = query.objectStatus;
            this.baseFormInfo.baseInfo.objectStatusConfDictId = query.objectStatusConfDictId;
            this.baseFormInfo.baseInfo.objectName = query.objectName;
            this.baseFormInfo.baseInfo.objectNumber = query.objectNumber;
            this.baseFormInfo.baseInfo.currency = query.currency;
            this.baseFormInfo.baseInfo.currencyId = query.currencyId + "";
            this.baseFormInfo.baseInfo.statementType = "pu_tong:statement_type";
            this.baseFormInfo.baseInfo.approvalAmount = "";
            this.baseFormInfo.baseInfo.businessName = "";
            this.baseFormInfo.baseInfo.currencyAmount = "";
            this.baseFormInfo.baseInfo.financeInAmount = "";
            this.baseFormInfo.baseInfo.financeOutAmount = "";
            // baseFormInfo.baseInfo.reconciliationDeptId = "";
            this.baseFormInfo.baseInfo.settlementAmount = "";
            utils.getSelectData("", 4).then((res) => {
              this.currencyOptions = res.arr;
            });
            // onSelectCurrencyByName(query.currency);
            // baseFormInfo.baseInfo.statementCurrencyId = query.currencyId;
            // baseFormInfo.baseInfo.statementCurrency = query.currency;
            // baseFormInfo.baseInfo.statementCurrencyExchange = "1";

            this.baseFormInfo.baseInfo.statementModeConfDictId = "";
            this.baseFormInfo.baseInfo.writeoffComment = "";
            this.baseFormInfo.baseInfo.zjAccount = "";
            this.originalCurrency.originCurrencyId = query.currencyId + "";
            this.originalCurrency.statementCurrency = query.currency;
            // onSelectCurrencyByName(query.currency);
            let ysTableStorageSelectData = JSON.parse(
                sessionStorage.getItem("ysTableStorageSelectData")
            );
            if (utils.jyCheckObjectType(ysTableStorageSelectData) == "Array") {
              ysTableStorageSelectData.forEach((element) => {
                if (element.financeId) {
                  let objfinanceType = "finance_in";
                  let objfinanceTypeShow = "应收";
                  let objdocumentStatus = "";
                  let objdocumentStatusShow = "运单";
                  let objdocumentNumber = element.waybillNumber;
                  let objObjectName = element.userMemberName;
                  let objnoTaxTotalAmount = element.noTaxTotalAmount;
                  if(query.financeType == "finance_record_group"){
                    objfinanceType = "finance_record_group";
                    objfinanceTypeShow = "应收";
                    objdocumentStatus = "finance_record_group";
                    objdocumentStatusShow = "运费单";
                    objdocumentNumber = element.financeNumber;
                    objObjectName = element.objectName;
                    objnoTaxTotalAmount = element.totalFreight;
                  }

                  let obj = {
                    financeId: element.financeId,
                    financeType: objfinanceType,
                    operationType: "ADD",
                    createTime: element.createTime,
                    financeNumber: element.financeNumber,
                    financeTypeShow: objfinanceTypeShow,
                    documentStatus: objdocumentStatus,
                    documentStatusShow: objdocumentStatusShow,
                    documentNumber: objdocumentNumber,
                    categoryName: "",
                    serviceName: "",
                    objectStatus: query.objectStatus,
                    objectStatusConfDictId: query.objectStatusConfDictId || "",
                    objectName: objObjectName,
                    currency: element.currency,
                    currencyId: element.currencyId + "" || "",
                    financeInAmount: element.totalFreight || 0,
                    noTaxTotalAmount: objnoTaxTotalAmount || 0,
                    financeOutAmount: 0,
                    writeoffCcomment: "",
                    waybillCreateTime: "",
                  };
                  this.financeTable.push(obj);
                }
              });
            }
          }
        }
      },
      immediate: true
    },

    financeTable: {
      handler: function(newValue, oldValue) {
        let rows = newValue.length > 0 ? newValue[0] : [];

        if (newValue.length > 0) {
          this.baseFormInfo.baseInfo.currency = rows.currency;
          this.baseFormInfo.baseInfo.currencyId = rows.currencyId;
          this.baseFormInfo.baseInfo.statementCurrencyId = rows.currencyId;
          this.baseFormInfo.baseInfo.statementCurrency = rows.currency;
          this.baseFormInfo.baseInfo.statementCurrencyExchange = 1;
        } else {
          return false;
        }

        // 应收金额
        let financeInAmount = 0;
        // 应付金额
        let financeOutAmount = 0;
        newValue.forEach((item) => {
          if (!isNaN(item.financeInAmount) && item.financeInAmount != "") {
            financeInAmount =
                parseFloat(financeInAmount || 0) +
                parseFloat(item.financeInAmount || 0);
          }
          if (!isNaN(item.financeOutAmount) && item.financeOutAmount != "") {
            financeOutAmount =
                parseFloat(financeOutAmount || 0) +
                parseFloat(item.financeOutAmount || 0);
          }
        });
        this.baseFormInfo.baseInfo.financeInAmount = parseFloat(financeInAmount).toFixed(
            this.commonJumpKeys.toFixedNum
        );
        this.baseFormInfo.baseInfo.financeOutAmount = parseFloat(
            financeOutAmount
        ).toFixed(this.commonJumpKeys.toFixedNum);

        let num =
            parseFloat(financeInAmount || 0) - parseFloat(financeOutAmount || 0);
        this.baseFormInfo.baseInfo.settlementAmount = num.toFixed(
            this.commonJumpKeys.toFixedNum
        );
        if (
            !isNaN(this.baseFormInfo.baseInfo.statementCurrencyExchange) &&
            this.baseFormInfo.baseInfo.statementCurrencyExchange != ""
        ) {
          let numA =
              parseFloat(this.baseFormInfo.baseInfo.statementCurrencyExchange) *
              parseFloat(this.baseFormInfo.baseInfo.settlementAmount || 0);

          this.baseFormInfo.baseInfo.currencyAmount = numA.toFixed(
              this.commonJumpKeys.toFixedNum
          );
          this.baseFormInfo.baseInfo.approvalAmount = numA.toFixed(
              this.commonJumpKeys.toFixedNum
          );
        }
      },
      immediate: true,
      deep: true
    }
  },

  mounted() {
    this.windowResize();
    window.onresize = () => {
      this.windowResize();
    };

    utils.getSelectData("object_status", 3).then((res) => {
      this.objectStatusOptions = res.arr;

      // // 默认结算对象类型是会员
      // this.objectStatusOptions.forEach((item) => {
      //   if (item.keyType == "customer:object_status") {
      //     this.baseFormInfo.baseInfo.objectStatusConfDictId = item.confDictId;
      //   }
      // });
    });

    // 默认部门
    utils
        .getSelectData("storage_choose_list", 1, [
          {
            conditonKey: "isDefault",
            conditonVal: "1",
          },
        ])
        .then((res) => {
          if (res.arr && res.arr.length > 0) {
            let arrs = res.arr || [];
            if (arrs.length > 0) {
              const obj = arrs[0];
              console.log("obj", obj);
              this.baseFormInfo.baseInfo.reconciliationDept = obj.storageName;
              this.baseFormInfo.baseInfo.reconciliationDeptId = obj.storageId * 1;

              this.storageOptions = [
                {
                  storageName: obj.storageName,
                  storageId: obj.storageId,
                },
              ];
              // utils.getSelectData("storage_choose_list", 1).then((res) => {
              //   storageOptions.value = res.arr;
              // });
            }

            // baseFormInfo.baseInfo.reconciliationDept = obj.storageName;
            // baseFormInfo.baseInfo.reconciliationDeptId = obj.storageId;
          }
        });
  },

  methods: {
    windowResize() {
      let clientWidth = document.body.clientWidth;
      if (clientWidth <= 1760) {
        this.span = 8;
      } else {
        this.span = 8;
      }
    },

    visibleChange(val, type) {
      if (val) {
        if (type == 1) {
          utils.getSelectData("object_status", 3).then((res) => {
            this.objectStatusOptions = res.arr;
          });
        } else if (type == 2) {
          utils.getSelectData("member_down_list", 9).then((res) => {
            this.objectNameOptions = res.arr;
          });
        } else if (type == 3) {
          if (this.commonJumpKeys.isAllDept) {
            // 所有部门/仓库/网点
            utils.getSelectData("dept_storage_choose_list", 1).then((res) => {
              this.storageOptions = res.arr;
            });
          } else {
            // 部门下拉列表
            utils.getSelectData("storage_choose_list", 1).then((res) => {
              this.storageOptions = res.arr;
            });
          }
        } else if (type == 4) {
          utils.getSelectData("", 4).then((res) => {
            this.currencyOptions = res.arr;
          });
        } else if (type == 5) {
          utils.getSelectData("statement_mode", 3).then((res) => {
            this.statementModeOptions = res.arr;
          });
        } else if (type == 6) {
          utils.getSelectData("zj_account_down_list", 1).then((res) => {
            this.zjAccountOptions = res.arr;
          });
        }
      }
    },

    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.baseFormInfo.baseInfo[type[1]] = obj[select[1]];
        }
      }
      this.baseFormInfo.baseInfo[type[0]] = val;
    },

    onSelectCurrency(val) {
      let arr = this.currencyOptions.filter((value, index) => {
        return value.currencyId == val;
      });

      if (arr && arr.length > 0) {
        let obj = arr[0];
        this.baseFormInfo.baseInfo.statementCurrency = obj.cnName;
        if (
            !this.baseFormInfo.baseInfo.statementCurrencyId ||
            !this.baseFormInfo.baseInfo.currencyId
        ) {
          return false;
        }
        // 获取汇率
        let param = {
          destCurrencyAbbrName: "",
          destCurrencyId: this.baseFormInfo.baseInfo.statementCurrencyId || "", //目标币种
          originalCurrencyAbbrName: "",
          originalCurrencyId: this.baseFormInfo.baseInfo.currencyId || "", //原币种
        };

        Api.getRateValue(param)
            .then((res) => {
              this.baseFormInfo.baseInfo.statementCurrencyExchange =
                  Number(res.data.result || 0) || 1;
              this.baseFormInfo.baseInfo.currencyAmount = (
                  this.baseFormInfo.baseInfo.statementCurrencyExchange *
                  this.baseFormInfo.baseInfo.settlementAmount
              ).toFixed(this.commonJumpKeys.toFixedNum);
              this.baseFormInfo.baseInfo.approvalAmount =
                  this.baseFormInfo.baseInfo.currencyAmount;
            })
            .catch(() => {
              this.baseFormInfo.baseInfo.statementCurrencyExchange;
              this.baseFormInfo.baseInfo.currencyAmount = "0.00";
              this.baseFormInfo.baseInfo.currencyAmount = "0.00";
            });
      }
    },

    onSelectCurrencyByName(val) {
      let arr = this.currencyOptions.filter((value, index) => {
        return value.cnName == val;
      });
      if (arr && arr.length > 0) {
        let obj = arr[0];
        // 获取汇率
        if (!this.originalCurrency.originCurrencyId) {
          return false;
        }
        let param = {
          destCurrencyAbbrName: "",
          destCurrencyId: obj.currencyId || "",
          originalCurrencyAbbrName: "",
          originalCurrencyId: this.originalCurrency.originCurrencyId || "",
        };
        Api.getRateValue(param)
            .then((res) => {
              this.baseFormInfo.baseInfo.statementCurrencyExchange =
                  Number(res.data.result || 0) || 1;
              this.baseFormInfo.baseInfo.currencyAmount = (
                  this.baseFormInfo.baseInfo.statementCurrencyExchange *
                  this.baseFormInfo.baseInfo.settlementAmount
              ).toFixed(this.commonJumpKeys.toFixedNum);
              this.baseFormInfo.baseInfo.approvalAmount =
                  this.baseFormInfo.baseInfo.currencyAmount;
            })
            .catch(() => {
              this.baseFormInfo.baseInfo.statementCurrencyExchange;
              this.baseFormInfo.baseInfo.currencyAmount = "0.00";
              this.baseFormInfo.baseInfo.currencyAmount = "0.00";
            });
      }
    },

    onSelectObjectName(val) {
      let arr = this.objectNameOptions.filter((value, index) => {
        return value.memberId == val;
      });
      if (arr && arr.length > 0) {
        let obj = arr[0];
        this.baseFormInfo.baseInfo.objectNumber = obj.memberId;
        this.baseFormInfo.baseInfo.objectName = obj.userMemberName;
      }
    },

    onAddFinanceRecordGroup() {
      this.addFinanceRecordGroupVisible = true;
    },

    onCancelAddFinanceRecordGroup() {
      this.addFinanceRecordGroupVisible = false;
    },

    onConfirmAddFinanceRecordGroup(msg) {
      if (msg) {
        for (let i = 0; i < this.financeTable.length; i++) {
          if (this.financeTable[i].documentNumber == msg) {
            ElMessage({
              message: "运费单单号已存在！",
              type: "warning",
            });
            return;
          }
        }
        let qArr = [];
        let obj = {
          conditonKey: "frgNumberNotLike",
          conditonVal: msg,
        };
        qArr.push(obj);
        Api.runPageReport({
          conditionReqs: qArr,
          number: "finance_waybill_fee_list",
          pageStart: 1,
          pageTotal: 100,
        }).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.status == "success") {
              let result = data.result;
              const rdatas = result.datas;
              let tableArr = rdatas.data;
              if (utils.jyCheckObjectType(tableArr) == "Array") {
                let has = false;
                if (tableArr.length > 0) {
                  for (let i = 0; i < tableArr.length; i++) {
                    const element = tableArr[i];

                    for (let i = 0; i < this.financeTable.length; i++) {
                      if (
                          this.financeTable[i].documentNumber ==
                          element.financeNumber
                      ) {
                        ElMessage({
                          message: "运费单单号已存在！",
                          type: "warning",
                        });
                        return false;
                      }
                    }

                    if (this.baseFormInfo.baseInfo.objectName) {
                      if (
                          element.objectName != this.baseFormInfo.baseInfo.objectName
                      ) {
                        ElMessage({
                          message: "结算对象不一致！",
                          type: "error",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.objectName = element.objectName;
                    }
                    // if (baseFormInfo.baseInfo.objectNumber) {
                    //   if (element.objectNumber != baseFormInfo.baseInfo.objectNumber) {
                    //     ElMessage({
                    //       message: "结算对象不一致！",
                    //       type: "error",
                    //     });
                    //     return;
                    //   }
                    // } else {
                    //   baseFormInfo.baseInfo.objectNumber = element.memberId;
                    // }
                    this.baseFormInfo.baseInfo.objectNumber = element.objectNumber;
                    this.baseFormInfo.baseInfo.objectStatusConfDictId = element.objectStatusConfDictId+ "";
                    if (!element.currency) {
                      ElMessage({
                        message: "结算币种不存在！",
                        type: "error",
                      });
                      return;
                    }
                    if (this.baseFormInfo.baseInfo.currency) {
                      if (element.currency != this.baseFormInfo.baseInfo.currency) {
                        ElMessage({
                          message: "币种不一致！",
                          type: "error",
                        });
                        return;
                      }
                      this.baseFormInfo.baseInfo.currency = element.currency;
                      this.baseFormInfo.baseInfo.currencyId = element.currencyId + "";
                    } else {
                      this.baseFormInfo.baseInfo.currency = element.currency;
                      this.baseFormInfo.baseInfo.currencyId = element.currencyId + "";
                    }
                    if (!element.financeId) {
                      ElMessage({
                        message: "运费单有误,请重新添加！",
                        type: "error",
                      });
                      return;
                    }
                    let obj = {
                      financeId: element.financeId,
                      financeType: "finance_record_group",
                      operationType: "ADD",
                      createTime: element.businessDate,
                      financeNumber: element.financeNumber,
                      financeTypeShow: "应收",
                      documentStatus: "finance_record_group",
                      documentStatusShow: "运费单",
                      documentNumber: element.financeNumber,
                      categoryName: "",
                      serviceName: "",
                      objectStatusConfDictId: element.objectStatusConfDictId,
                      objectStatus: element.objectStatus,
                      objectName: element.objectName,
                      currency: element.currency,
                      currencyId: element.currencyId || "",
                      financeInAmount: element.totalFreight || 0,
                      noTaxTotalAmount: element.totalFreight || 0,
                      financeOutAmount: 0,
                      writeoffCcomment: "",
                      waybillCreateTime: "",
                    };
                    this.financeTable.push(obj);
                  }
                }else{
                  ElMessage({
                    message: "查不到数据！",
                    type: "error",
                  });
                  return;
                }
              }else{
                ElMessage({
                  message: "查不到数据！",
                  type: "error",
                });
                return;
              }
            }
          }
          this.addFinanceRecordGroupVisible = false;
        });
      }
    },

    onAddWaybill() {
      this.addWaybillVisible = true;
    },

    onDelWaybill() {
      if (this.mxTableSelect.length > 0) {
        this.$confirm("是否删除选定数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              this.mxTableSelect.forEach((value, key) => {
                this.financeTable.forEach((item, index) => {
                  if (value.financeId == item.financeId) {
                    this.financeTable.splice(index, 1);
                  }
                });
              });
            })
            .catch(() => {});
      } else {
        ElMessage({
          message: "请选择明细表格数据！",
          type: "warning",
        });
      }
    },

    // 装载明细表格数据选中
    handleMxTableChange(val) {
      this.mxTableSelect = val;
    },

    onCancelAddWaybill() {
      this.addWaybillVisible = false;
    },

    // 输出运单
    onConfirmAddWaybill(msg) {
      if (msg) {
        for (let i = 0; i < this.financeTable.length; i++) {
          if (this.financeTable[i].documentNumber == msg) {
            ElMessage({
              message: "运单号已存在！",
              type: "warning",
            });
            return;
          }
        }
        let obj1 = {
          waybillNumber: msg,
        };
        const obj2 = {
          pageStart: 1,
          pageTotal: 1,
          pageCount: 1,
          papeStart: 1,
          isCustomes: 0,
        };
        const obj3 = Object.assign({}, obj1, obj2);
        Api.getWaybillList(obj3).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.status == "success") {
              let result = data.result;
              let tableArr = result.data;
              if (utils.jyCheckObjectType(tableArr) == "Array") {
                let has = false;
                if (tableArr.length > 0) {
                  for (let i = 0; i < tableArr.length; i++) {
                    const element = tableArr[i];

                    for (let i = 0; i < this.financeTable.length; i++) {
                      if (
                          this.financeTable[i].documentNumber ==
                          element.waybillNumber
                      ) {
                        ElMessage({
                          message: "运单号已存在！",
                          type: "warning",
                        });
                        return false;
                      }
                    }

                    if (this.baseFormInfo.baseInfo.objectName) {
                      if (
                          element.userMemberName != this.baseFormInfo.baseInfo.objectName
                      ) {
                        ElMessage({
                          message: "客户名称不一致！",
                          type: "error",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.objectName = element.userMemberName;
                    }
                    if (this.baseFormInfo.baseInfo.objectNumber) {
                      if (element.memberId != this.baseFormInfo.baseInfo.objectNumber) {
                        ElMessage({
                          message: "客户代码不一致！",
                          type: "error",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.objectNumber = element.memberId;
                    }
                    if (!element.currency) {
                      ElMessage({
                        message: "结算币种不存在！",
                        type: "error",
                      });
                      return;
                    }
                    if (this.baseFormInfo.baseInfo.currency) {
                      if (element.currency != this.baseFormInfo.baseInfo.currency) {
                        ElMessage({
                          message: "币种不一致！",
                          type: "error",
                        });
                        return;
                      }
                      this.baseFormInfo.baseInfo.currency = element.currency;
                      this.baseFormInfo.baseInfo.currencyId = element.currencyId;
                    } else {
                      this.baseFormInfo.baseInfo.currency = element.currency;
                      this.baseFormInfo.baseInfo.currencyId = element.currencyId;
                    }
                    if (!element.financeId) {
                      ElMessage({
                        message: "运单未审核！",
                        type: "error",
                      });
                      return;
                    }

                    let obj = {
                      financeId: element.financeId,
                      financeType: "finance_record_group",
                      operationType: "ADD",
                      createTime: element.createTime,
                      financeNumber: element.financeNumber,
                      financeTypeShow: "应收",
                      documentStatus: "",
                      documentStatusShow: "运单",
                      documentNumber: element.waybillNumber,
                      categoryName: "",
                      serviceName: "",
                      objectStatus: "",
                      objectName: element.userMemberName,
                      currency: element.currency,
                      currencyId: element.currencyId || "",
                      financeInAmount: element.totalFreight || 0,
                      noTaxTotalAmount: element.noTaxTotalAmount || 0,
                      financeOutAmount: 0,
                      writeoffCcomment: "",
                      waybillCreateTime: "",
                    };
                    this.financeTable.push(obj);
                  }
                }
              }
            }
          }
          this.addWaybillVisible = false;
        });
      }
    },

    onSave() {
      // let arr = [];
      // domCommonFuJian.value.annexTable.forEach((item) => {
      //   if (item.status == "success") {
      //     arr.push({
      //       "fileId": item.name,
      //       "fileName": item.name
      //     });
      //   }
      // });

      let submitData = utils.oldObjToNewObj(this.submitObj, this.baseFormInfo.baseInfo);
      let documentBills = [];
      this.financeTable.forEach((element) => {
        let obj = {
          billTmsWaybillId: element.billTmsWaybillId || null,
          financeId: element.financeId,
          financeType: element.financeType,
          operationType: "ADD",
        };
        documentBills.push(obj);
      });

      let files = this.$refs.domCommonFuJian.annexTable || [];
      let DELFilesList = this.$refs.domCommonFuJian.DELFilesList || [];
      let pFiles = [...files, ...DELFilesList];
      let fileLists = [];
      pFiles.forEach((itemA) => {
        let obj = {
          fileId: itemA.fileId,
          fileName: itemA.fileId,
          operationType: itemA.operationType,
        };
        fileLists.push(obj);
      });

      let params = Object.assign(
          { baseInfo: submitData },
          { documentBills: documentBills },
          { fileList: fileLists }
      );
      Api.createStatement(params).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) == "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    }
  },

  created() {
    sessionStorage.setItem("clearReceivableManagementCenerateStatement", 1);
    this.bBaseFormInfo = utils.relObjRam(this.baseObj.baseInfo);
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.jy-form-container {
  padding: 20px;
  padding-bottom: 100px;
  background: #fff;
  border-radius: 6px;
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}

.tag-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tag-list {
  display: flex;
  margin-top: 15px;

  .tag-span {
    width: 80px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 2px dashed red;
    color: red;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}
</style>
